import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnter.styl';

import './BXmakerAuthuserphoneEnterAuth';
import './BXmakerAuthuserphoneEnterReg';
import './BXmakerAuthuserphoneEnterForget';


Vue.component('BXmakerAuthuserphoneEnter', {
    name: 'BXmakerAuthuserphoneEnter',
    data() {
        return {

        };
    },
    computed: {


    },
    methods: {

    },
    template: `
            <div class="bxmaker-authuserphone-enter" :id="'bxmaker-authuserphone-enter__' + $root.rand" >
                
                <BXmakerAuthuserphoneEmpty v-if="$root.isAuthorized" >
                 {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_IS_AUTHORIZED}} <br>
                    <a href="?logout=Y">{{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_LOGOUT}}</a>
                 </BXmakerAuthuserphoneEmpty>                 
                               
                <BXmakerAuthuserphoneEnterAuth v-show="$root.actionTypeIsAuth && !$root.isAuthorized" />
                
                <BXmakerAuthuserphoneEnterReg v-show="$root.actionTypeIsReg && !$root.isAuthorized && this.$root.isEnabledRegister" />
                
                <BXmakerAuthuserphoneEnterForget v-show="$root.actionTypeIsForget && !$root.isAuthorized" />                        
                             
            </div>
        `,
});